module.exports = __webpack_public_path__ + "assets/img/s5-subtitle-3-8ca5a9fe.png";